<template>
  <b-nav pills vertical class="sidebar">
    <li v-for="item in menuItems" class="nav-item">
      <template >
        <router-link class="nav-link" :to="{ name: item.name }">{{item.title}}</router-link>
      </template>
    </li>
  </b-nav>
</template>

<script>
import SidebarMenuItems from '@/data/ProfileSidebarMenu'

export default {
  name: 'sidebar',
  computed: {
    menuItems () {
      let userRole = this.$store.state.auth.user.role

      return SidebarMenuItems.filter(item => {
        const itemRole = item.meta.role
        if (itemRole === userRole) {
          return true
        }

        const roleHierarchy = {
          manager: ['user'],
          admin: ['manager', 'user']
        }

        return userRole in roleHierarchy &&
              roleHierarchy[userRole].indexOf(itemRole) !== -1
      })
    }
  }
}
</script>

<style scoped>
  li.nav-item {
    border-top: 2px solid #fff;
  }
  .sidebar {
    margin-bottom: 15px;
    background-color: rgba(0, 0, 0, 0.04);
  }
  .sidebar a{
    color: rgba(70, 74, 76, 0.82);
  }
  .nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link, a.nav-link:hover {
    background-color: rgba(0, 0, 0, 0.3);
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?af36e5f2